import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";

import Header from "./components/Header";
import Footer from "./components/Footer";

import imgConfirmation from "../images/confirmation.png"

const Confirmation = () => {
    const { orderId } = useParams();

    const [token] = useState(sessionStorage.getItem("token"));
    const [order, setOrder] = useState([]);
    const [organizerId, setOrganizerId] = useState(0);

    const [error, setError] = useState(null);

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching resources
    const { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        loadToken();
    }, []); //only on first page load

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const loadToken = async () => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        requestFormSettings()
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setOrganizerId(res.data.organizerId);
            loadOrder(orderId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId, attempt = 1) => {
        try {
            const fetchedOrder = await getOrderByOrderId(orderId);

            // If invoiceNumber missing and attempts < 7, retry
            if ((!fetchedOrder?.invoiceNumber || fetchedOrder.invoiceNumber === "") && attempt < 7) {
                console.log(`Retrying to fetch order... Attempt ${attempt + 1}`);
                await new Promise((resolve) => setTimeout(resolve, 2000)); // optional delay before retry
                return loadOrder(orderId, attempt + 1);
            }

            if (!fetchedOrder?.invoiceNumber) {
                setError("Invoice number is missing after multiple attempts.");
            } else {
                setError(null);
            }

            setOrder(fetchedOrder);
        } catch (error) {
            console.error(error);
            setError("Failed to load order.");
        }
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const getReceiptOfOrder = async () => {
        await axios
            .get(`${baseUrl}/Order/${orderId}/Receipt?organizerId=${organizerId}`, {
                responseType: "blob",
            })
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Receipt.pdf";
                link.click();
            })
            .catch((error) => console.error(error.response.data));
    };

    const getPdfTicketsOfOrder = async () => {
        await axios
            .get(
                `${baseUrl}/Order/${orderId}/TicketsPdf?organizerId=${organizerId}`,
                {
                    responseType: "blob",
                }
            )
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Tickets.pdf";
                link.click();
            })
            .catch((error) => console.error(error.response.data));
    };

    return (
        <>
            <Header />
            <div className="container wrapper-smaller">

                {/* Show error message if any */}
                {error && (
                    <div className="alert alert-danger mt-3" role="alert">
                        <p dangerouslySetInnerHTML={{ __html: resources?.ErrorOrder?.replaceAll("${orderId}", orderId) }}></p>
                    </div>
                )}

                {!error && order && order.invoiceNumber && order.invoiceNumber !== 0 && (
                    <>
                        <div className="row mt-5 text-center">
                            <div className="col-md-12">
                                <span className="title dark-blue">thank you!</span><br />
                            </div>
                        </div>

                        <div className="row mt-5 text-center">
                            <div className="col-md-12">
                                <img className="img-fluid" src={imgConfirmation} alt="" />
                            </div>
                        </div>

                        <div className="row mt-5 text-center">
                            <div className="col-md-12">
                                <span className="dark-blue">
                                    You will receive your personalized tickets by email.
                                    <br /><br />
                                    Please check your inbox. If the email doesn't appear within a few minutes, please check your spam or junk folder.
                                    <br /><br />
                                    You can find more information <a href="https://www.swissfintechweek.com/about" rel="noreferrer" target="_blank">here</a>.
                                </span>
                            </div>
                        </div>

                        <div className="row mt-5 text-center">
                            <div className="col-md-12">
                                <button
                                    className="btn btn-custom"
                                    onClick={() => getPdfTicketsOfOrder()}
                                >
                                    DOWNLOAD TICKET
                                </button>
                            </div>
                        </div>

                        <div className="row mt-5 text-center">
                            <div className="col-md-12 dark-blue">
                                <span>We look forward to seeing you!</span>
                            </div>
                        </div>

                        <div className="row mt-5 text-center">
                            <div className="col-md-12">
                                <button
                                    className="btn btn-custom-blue"
                                    onClick={() => window.location.href = 'https://www.swissfintechweek.com'}
                                >
                                    BACK TO HOMEPAGE
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <div className="container wrapper">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <Footer language={language} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Confirmation